import { RoutePath } from '@/routes'
import { PageId, PageIdInfo } from './types'

export const pageIdInfos: { [Key in PageId]: PageIdInfo<Key>; } = Object.freeze({
  main: {
    pageId: 'main',
    url: RoutePath.Home,
    name: '운전점수 메인',
  },
  benefit_home: {
    pageId: 'benefit_home',
    url: RoutePath.Benefit_home,
    name: '혜택홈',
  },
  benefit_list: {
    pageId: 'benefit_list',
    url: RoutePath.Benefit_list,
    name: '혜택 목록',
  },
  // benefit, benefit_popular 들어온 경우는 레거시 리디렉션
  benefit: {
    pageId: 'benefit',
    url: RoutePath.Benefit_list,
    name: '혜택 목록',
  },
  benefit_popular: {
    pageId: 'benefit_popular',
    url: RoutePath.Benefit_home,
    name: '혜택홈',
  },
  // benefit_detail 들어온 경우는 보험 상세로 랜딩
  benefit_detail: {
    pageId: 'benefit_detail',
    url: RoutePath.Benefit_detail,
    name: '혜택 > 보험 상세(자동차보험)',
  },
  benefit_point: {
    pageId: 'benefit_point',
    url: RoutePath.Benefit_point,
    name: '포인트혜택',
  },
  insurance_tab: {
    pageId: 'insurance_tab',
    url: RoutePath.Insurance_tab,
    name: '혜택(보험)',
  },
  // 마이 > 자동차보험으로 들어온 경우 혜택(자동차보험)으로 랜딩
  insur_vehicle_all: {
    pageId: 'insur_vehicle_all',
    url: RoutePath.Benefit_list,
    name: '혜택(자동차보험)',
  },
  driving_analysis: {
    pageId: 'driving_analysis',
    url: RoutePath.Analysis,
    name: '운전분석',
  },
  driving_analysis_place: {
    pageId: 'driving_analysis_place',
    url: RoutePath.Analysis_place,
    name: '운전분석 > 내가 자주 방문한 장소 카테고리 상세',
  },
  driving_history: {
    pageId: 'driving_history',
    url: RoutePath.History,
    name: '운전이력',
  },
  trip_history: {
    pageId: 'trip_history',
    url: RoutePath.History,
    name: '운전이력',
  },
  driving_history_detail: {
    pageId: 'driving_history_detail',
    url: RoutePath.History_detail,
    name: '운전이력상세',
  },
  trip_history_detail: {
    pageId: 'trip_history_detail',
    url: RoutePath.History_detail,
    name: '운전이력상세',
  },
  vehicle: {
    pageId: 'vehicle',
    url: RoutePath.Vehicle,
    name: '내 차 리포트',
  },
  vehicle_setting: {
    pageId: 'vehicle_setting',
    url: RoutePath.Vehicle_setting,
    name: '내 차 선택',
  },
  vehicle_detail: {
    pageId: 'vehicle_detail',
    url: RoutePath.Vehicle_detail,
    name: '내 차 리포트 상세',
  },
  unpaid_toll: {
    pageId: 'unpaid_toll',
    url: RoutePath.Vehicle_unpaid_toll,
    name: '미납통행료 내역',
  },
  unpaid_toll_bridge: {
    pageId: 'unpaid_toll_bridge',
    url: RoutePath.Vehicle_unpaid_toll_bridge,
    name: '미납통행료 유비페이 브릿지',
  },
  unpaid_toll_result: {
    pageId: 'unpaid_toll_result',
    url: RoutePath.Vehicle_unpaid_toll_result,
    name: '미납통행료 결제 결과',
  },
  etc_insurer_contact: {
    pageId: 'etc_insurer_contact',
    url: RoutePath.Etc_insurer_contact,
    name: '보험사 연락처',
  },
  etc_emergency_call: {
    pageId: 'etc_emergency_call',
    url: RoutePath.Etc_emergency_call,
    name: '긴급 호출',
  },
  etc_terms: {
    pageId: 'etc_terms',
    url: RoutePath.Etc_terms,
    name: '운전점수 약관',
  },
  settings: {
    pageId: 'settings',
    url: RoutePath.Settings,
    name: '운전점수 셋팅 페이지',
  },
  settings_otp: {
    pageId: 'settings_otp',
    url: RoutePath.Settings_otp,
    name: 'OTP',
  },
  settings_withdrawal: {
    pageId: 'settings_withdrawal',
    url: RoutePath.Settings_withdrawal,
    name: '운전점수 탈퇴 페이지',
  },
  license_penalty: {
    pageId: 'license_penalty',
    url: RoutePath.License_penalty,
    name: '운전면허 벌점 브릿지',
  },
  license_penalty_input: {
    pageId: 'license_penalty_input',
    url: RoutePath.License_penalty_input,
    name: '운전면허 번호 입력',
  },
  license_penalty_result: {
    pageId: 'license_penalty_result',
    url: RoutePath.License_penalty_result,
    name: '운전면허 벌점 결과',
  },
  insurance_driver: {
    pageId: 'insurance_driver',
    url: RoutePath.Insurance_driver,
    name: '라이나 운전자 보험 가입 정보',
  },
  insurance_driver_history: {
    pageId: 'insurance_driver_history',
    url: RoutePath.Insurance_driver_history,
    name: '라이나 운전자 보험 이용내역 목록',
  },
  insurance_driver_history_detail: {
    pageId: 'insurance_driver_history_detail',
    url: RoutePath.Insurance_driver_history_detail,
    name: '라이나 운전자 보험 이용내역 상세',
  },
})
